hrd.components.form.AbstractNumericComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.AbstractNumericComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		field.addClass('right-align');
	},
	getEditableField: function(field, name, object, options) {
		var opts = field.autoNumeric('getSettings');
		var value = $.numericValue(field.val(), opts);
		if ((value == undefined || value == '') && (field.data('default') !== undefined)) {
			let defaultValue = field.data('default');
			/* fix for '': if default value '' is applied, then transform it to empty-string in output */
			if (defaultValue !== undefined && defaultValue !== "''") {
				value = defaultValue;
			}
		}
		this.setValueByPath(object, name, value);
		if (field.data('asNumber')) {
			this.setValueByPath(object, $.functionCase('n-' + name), field.autoNumeric('get'));
		}
	},
	setEditableField: function(field, value, object, options) {
		field.val(value);
		/* needed because there is a 'custom' formatting, so the style must be applied */
		if (field.data('formatStyle') != undefined) {
			field.autoNumeric('set', field.autoNumeric('get'));
		}
	},
	initalizeComponent: function(field, initialValue) {
		field.autoNumeric('set', initialValue);
	}
});